export default __webpack_public_path__ + "static/media/IBMSetting.590f41af.svg";